import { createContext, MutableRefObject, useContext, useEffect } from 'react';

// Shared ref consumed by Sidebar and registered by each Step. When the user clicks a
// sidebar step item, Sidebar invokes ref.current to persist the active step's in-flight
// form values to the AddQuote slice (no yup validation) BEFORE dispatching the step change,
// so navigating sideways via the sidebar no longer wipes the user's progress.
export const StepperPersistContext = createContext<MutableRefObject<(() => void) | null> | null>(null);

export const useRegisterStepperPersist = (persist: () => void) => {
    const ref = useContext(StepperPersistContext);

    // Re-register on every render so the closure captures the latest selector / form values.
    // Cleanup only clears the slot if we're still the active handler — guards against a race
    // where the next step's mount effect has already overwritten ref.current before our
    // unmount cleanup fires.
    useEffect(() => {
        if (!ref) return undefined;
        ref.current = persist;

        return () => {
            if (ref.current === persist) {
                ref.current = null;
            }
        };
    });
};
